import { createContext, useContext, useState, ReactNode } from 'react';

export type Role =
  | 'admin'
  | 'Manager'
  | 'Auditor'
  | 'Department Head'
  | 'Viewer';

type User = {
  name: string;
  email: string;
  avatar: string;
  fallback: string;
};

const userDetails: Record<Role, User> = {
  admin: {
    name: 'admin',
    email: 'admin@auditace.com',
    avatar: 'https://picsum.photos/seed/1/100/100',
    fallback: 'SA',
  },
  Manager: {
    name: 'Property Manager',
    email: 'manager@grandhyatt.com',
    avatar: 'https://picsum.photos/seed/2/100/100',
    fallback: 'PM',
  },
  Auditor: {
    name: 'Lead Auditor',
    email: 'auditor@external.com',
    avatar: 'https://picsum.photos/seed/3/100/100',
    fallback: 'LA',
  },
  'Department Head': {
    name: 'F&B Head',
    email: 'fb.head@grandhyatt.com',
    avatar: 'https://picsum.photos/seed/4/100/100',
    fallback: 'FH',
  },
  Viewer: {
    name: 'Regional Director',
    email: 'director@region.com',
    avatar: 'https://picsum.photos/seed/5/100/100',
    fallback: 'RD',
  },
};

interface RoleContextType {
  role: Role;
  setRole: (role: Role) => void;
  user: User;
}

const RoleContext = createContext<RoleContextType | undefined>(undefined);

export function RoleProvider({ children }: { children: ReactNode }) {
  const [role, setRole] = useState<Role>('admin');
  const user = userDetails[role];

  return (
    <RoleContext.Provider value={{ role, setRole, user }}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}
